import React from 'react'
import { Route, Routes } from 'react-router-dom'
import LoadableComponent from '../../utils/loadable'
import { withRouter } from '../../utils/router'
import { isAuthenticated } from '../../utils/session'

// Profile Manage
const ProfileInfo = LoadableComponent(() => import('../../containers/Profile/Info/index'))
const ProfileUpdate = LoadableComponent(() => import('../../containers/Profile/Update/index'))
const ProfilePassword = LoadableComponent(() => import('../../containers/Profile/Password/index'))

class ProfileMain extends React.Component {
    render() {
        if (!isAuthenticated()) {
            this.props.router.navigate("/login");
        }
        return (
            <div style={{ padding: 16, position: 'relative' }}>
                <Routes>
                    <Route path='/info' element={<ProfileInfo />} />
                    <Route path='/update' element={<ProfileUpdate />} />
                    <Route path='/password' element={<ProfilePassword />} />
                    <Route path='/*' element={<ProfileInfo />} />
                </Routes>
            </div>
        )
    }
}

export default withRouter(ProfileMain)